// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"c23b6fd0","141":"eaec7fd3","150":"1f510a39","328":"35d15c98","341":"8bba5f86","358":"9f3d0d09","445":"14df9093","515":"d3c02efd","535":"e19078fe","552":"53d58187","569":"44dd3a93","699":"30099baa","744":"4b2ea491","769":"57a71d8f","813":"c1fe37d3","924":"a2e7d68e"}[chunkId] + ".chunk.js";
};